<p-dialog [visible]="visible" (visibleChange)="onDialogVisibleChange($event)"
  [modal]="true" [draggable]="false" [resizable]="false" [dismissableMask]="true"
  [showHeader]="false" styleClass="photo-capture-dialog"
  [style]="{ width: '94vw', maxWidth: '880px', maxHeight: '92vh' }">

  <div class="pc-card">
    <div class="pc-header">
      <div class="pc-heading">
        <span class="pc-eyebrow"><i class="pi pi-shield"></i> Profile photo</span>
        <h3 class="pc-title">Take a live photo</h3>
      </div>
      <button type="button" class="pc-close" (click)="close()" aria-label="Close">
        <i class="pi pi-times"></i>
      </button>
    </div>

    <div class="pc-body">
      <!-- Camera / preview stage -->
      <div class="pc-stage">
        @if (state === 'streaming') {
        <span class="pc-badge"><span class="pc-dot"></span> LIVE PREVIEW</span>
        <video #video class="pc-media" autoplay playsinline muted
          (playing)="onVideoReady()" (loadeddata)="onVideoReady()"></video>
        <div class="pc-face-guide" [class.ready]="videoReady"></div>
        @if (!videoReady) {
        <div class="pc-loading"><span class="pc-spinner"></span> Starting camera…</div>
        }
        }
        @if (state === 'captured' && capturedPreviewUrl) {
        <img class="pc-media" [src]="capturedPreviewUrl" alt="Captured photo preview" />
        }
        @if (state === 'error') {
        <div class="pc-stage-error">
          <i class="pi pi-video"></i>
          <p>Camera unavailable</p>
        </div>
        }
      </div>

      <!-- Controls -->
      <div class="pc-controls">
        @if (state === 'streaming') {
        <p class="pc-note"><i class="pi pi-shield"></i> This photo is used for assessment identity verification and
          cannot be changed later. Please capture a clear, well-lit photo.</p>
        }

        @if (state === 'captured') {
        <p class="pc-ready">Looking great! Use this photo, or retake it if you'd like another shot.</p>
        } @else if (state === 'error') {
        <p class="pc-hint">{{ errorMessage }}</p>
        }

        @if (state === 'streaming') {
        <ul class="pc-tips">
          <li>Soft, even lighting</li>
          <li>Face centered in the oval</li>
          <li>Look straight at the camera</li>
        </ul>
        }

        <div class="pc-actions">
          @if (state === 'streaming') {
          <button pButton type="button" class="pc-primary" icon="pi pi-camera" label="Capture"
            [disabled]="!videoReady" (click)="capture()"></button>
          <button type="button" class="pc-text-btn" (click)="close()">Cancel</button>
          }
          @if (state === 'captured') {
          <label class="pc-agree">
            <input type="checkbox" [(ngModel)]="agreedToUpload" />
            <span>I confirm this photo is clear and agree to use it for assessment verification.</span>
          </label>
          <span class="pc-upload-wrap" pTooltip="Agree to the terms to upload" tooltipPosition="top"
            [tooltipDisabled]="agreedToUpload">
            <button pButton type="button" class="pc-primary" icon="pi pi-upload" label="Upload"
              [disabled]="!agreedToUpload" (click)="confirmUpload()"></button>
          </span>
          <button pButton type="button" class="pc-outlined" icon="pi pi-refresh" label="Retake"
            (click)="retake()"></button>
          }
          @if (state === 'error') {
          <button pButton type="button" class="pc-primary" icon="pi pi-refresh" label="Try again"
            (click)="startCamera()"></button>
          <button type="button" class="pc-text-btn" (click)="close()">Cancel</button>
          }
        </div>
      </div>
    </div>
  </div>

  <canvas #canvas hidden></canvas>
</p-dialog>
